import { render } from "./FadeTransition.vue?vue&type=template&id=4fbf5adb&scoped=true"
import script from "./FadeTransition.vue?vue&type=script&lang=js"
export * from "./FadeTransition.vue?vue&type=script&lang=js"

import "./FadeTransition.vue?vue&type=style&index=0&id=4fbf5adb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbf5adb"]])

export default __exports__